<template>
  <div class="d-flex flex-column flex-xl-row">
    <div class="display d-flex justify-content-center align-items-center">
      <img
        v-show="media.type === 'image'"
        class="img-fluid "
        :src="media.url"
        alt=""
      />
      <iframe
        v-show="media.type === 'video'"
        class="video-display"
        :src="media.url"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
    <highlight-box class=""></highlight-box>
  </div>
</template>

<script>
import HighlightBox from "@/components/HighlightBox/HighlightBox.vue";
export default {
  components: {
    HighlightBox,
  },
  computed: {
    media() {
      return this.$store.state.media.cards[this.$store.state.media.current];
    },
  },
};
</script>

<style src="./VitrineMedia.css" scoped></style>
